import { ProductType } from './Product';

export const products: ProductType[] = [
    {
        id: 1,
        name: "Hold fast: Armpynt",
        description: `Noen ganger krever livet at du holder deg fast. Denne kolleksjonen er derfor til en du vil gi en viktig påminnelse – om det er deg selv eller noen du er glad i. Velg pynt til håndleddet, ørene eller mobilen, men ikke glem at også dette skal forandre seg, det er bare å holde fast i mellomtiden!`,
        price: 79,
        image: "/hold-fast-arm_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 9,
        name: "Aldrimerpanikk-armbånd: Hvit",
        description: `Kom katastrofen i forkjøpet, og pynt barnet med telefonnummeret til foresatte. Aldri mer panikk for store folkemengder! Perfekt for 17. mai, festival eller storbyferie!
        
    Husk å skrive telefonnummer i bestillingen.`,
        price: 79,
        image: "/aldrimerpanikk_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 10,
        name: "Aldrimerpanikk-armbånd: Svart",
        description: `Kom katastrofen i forkjøpet, og pynt barnet med telefonnummeret til foresatte. Aldri mer panikk for store folkemengder! Perfekt for 17. mai, festival eller storbyferie!
        
    Husk å skrive telefonnummer i bestillingen.`,
        price: 79,
        image: "/aldrimerpanikk-svart_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {    
        id: 4,
        name: "Fruktpakke",
        description: `Bli litt mer fruity, da vel, og ta en sjanse med en saftig fruktpakke! Gjennoppliv smykkeskrinet med fire eksplosjoner av farger og kreativitet – perfekt for de som tør å skille seg litt ut! En herlig samling av fire eksklusive armbånd, hver med sin egen unike og fargerike stil.`,
        price: 149,
        image: "/fruktpakke_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 5,
        name: "Håndleddspoesi: Bee good",
        description: `La perlene gjøre snakkinga! Disse armbåndene er mer enn pynt, de er din stemme i perlens form. 

    Dette armbåndet stikker seg ut i mengden, og skaper blomstrete smil i hverdagen. Med et tydelig budskap om å være snill og god, og ta vare på de andre biene i kuben din. Disse perlene er ikke tilfeldige – de er med vilje!`,
        price: 79,
        image: "/handleddspoesi-3_1x1.png",
        category: "armband",
        inStock: false,
        size: ["S", "M", "L"]
    },
    {
        id: 3,
        name: "Håndleddspoesi: Faen ta",
        description: `La perlene gjøre snakkinga! Disse armbåndene er mer enn pynt, de er din stemme i perlens form. 

    Det er lett å bli litt forbanna når alle tror du bare er søt og snill. Skaff deg et bokstavarmbånd som viser at du er til å ta på alvor!`,
        price: 79,
        image: "/handleddspoesi-1_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 6,
        name: "Håndleddspoesi: High five",
        description: `Når det som er A4 er av moten – ta sats inn i en high five med alle du møter. Armbåndets kombinasjon av bokstaver og en utstrakt hånd gjør denne håndsrekningen vanskelig å stå imot, selv for de mest sjenerte typer. La oss lage gode vibber til den nye trenden!`,
        price: 79,
        image: "/handleddspoesi-4_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 8,
        name: "Håndleddspoesi: BFF",
        description: `Gi dette armbåndet til din beste venn for å vise at det er et menneske du virkelig setter pris på! Husk: Den du gir dette armbåndet til er ikke tilfeldig, det er med vilje!`,
        price: 79,
        image: "/handleddspoesi-5_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 2,
        name: "Kule kuler",
        description: `Kule kuler på en snor – dette er et eksklusivt armbånd av naturstein som kan matche et hvilket som helst antrekk. Uttrykksfull, men klassisk. Laget for å gi håndleddet ditt et elegant preg – dette er pynt med vilje!`,
        price: 99,
        image: "/klassiske-armband-1_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 7,
        name: "Cherry me up!",
        description: `Et kirsebærkyss på håndleddet! Dette er en gledespreder av et armbånd, med et levende design fra Perler med Vilje.`,
        price: 79,
        image: "/klassiske-armband-2_1x1.png",
        category: "armband",
        inStock: true,
        size: ["S", "M", "L"]
    },
    {
        id: 11,
        name: "Hold fast: Ørepynt",
        description: `Noen ganger krever livet at du holder deg fast. Denne kolleksjonen er derfor til en du vil gi en viktig påminnelse – om det er deg selv eller noen du er glad i. Velg pynt til håndleddet, ørene eller mobilen, men ikke glem at også dette skal forandre seg, det er bare å holde fast i mellomtiden!`,
        price: 69,
        image: "/hold-fast-ore_1x1.png",
        category: "orepynt",
        inStock: true,
    },
    {
        id: 12,
        name: "Hvit eleganse",
        description: `Denne ørepynten er enkel og glamorøs, og kan gjøre både festen finere og hverdagen fjongere. Du som har en vilje til eleganse – disse er til deg!`,
        price: 69,
        image: "/klassisk-orepynt-3-1_1x1.png",
        images: ["/klassisk-orepynt-3-1_1x1.png", "/klassisk-orepynt-3_1x1.png"],
        category: "orepynt",
        inStock: true,
    },
    {
        id: 13,
        name: "Beige eleganse",
        description: `Sett prikken over i-en på antrekket ditt med øredobber som uttrykker noe unikt. Til fest eller
hverdags, ikke la ørepynten være tilfeldig – bruk perler med vilje!`,
        price: 69,
        image: "/klassisk-orepynt-1_1x1.png",
        category: "orepynt",
        inStock: true,
    },
    {
        id: 14,
        name: "Fiolfine dobber",
        description: `Blomstrete ørepynt som er mer enn bare fjas – et tydelig statement om hvem du er og hva du føler!`,
        price: 69,
        image: "/klassisk-orepynt-2_1x1.png",
        category: "orepynt",
        inStock: true,
    },
    {
        id: 15,
        name: "Quotelobes: Peace and love",
        description: `Hev standarden for ørepynt med perler som virkelig teller! Quotelobes gjør deg både lekker og skarp – med et dinglende budskap om fred og kjærlighet. En inspirerende oppfordring i mørke tider – heng et lyspunkt i ørene!`,
        price: 69,
        image: "/quotelobes-1_1x1.png",
        images: ["/quotelobes-1_1x1.png", "/quotelobes-2_1x1.png"],
        category: "orepynt",
        inStock: true,
    },
    {
        id: 16,
        name: "Hold fast: Mobilpynt",
        description: `Noen ganger krever livet at du holder deg fast. Denne kolleksjonen er derfor til en du vil gi en viktig påminnelse – om det er deg selv eller noen du er glad i. Velg pynt til håndleddet, ørene eller mobilen, men ikke glem at også dette skal forandre seg, det er bare å holde fast i mellomtiden!`,
        price: 59,
        image: "/hold-fast-mobil_1x1.png",
        category: "mobilpynt",
        inStock: true,
    },
    {
        id: 17,
        name: "Blue but happy",
        description: `Ikke la noen andre fortelle deg hvordan mobilen din skal se ut!

Et dinglende anheng i blått som løfter humøret på sekundet.`,
        price: 59,
        image: "/mobilpynt-1_1x1.png",
        category: "mobilpynt",
        inStock: true,
    },
    {
        id: 18,
        name: "Grønt er skjønt",
        description: `Aldri har det vært lettere å ta et grønt valg. Kanskje kan denne mobilpynten minne deg om å ta en tur ut i skogen i stedet for å scrolle bort den neste timen?`,
        price: 59,
        image: "/mobilpynt-2_1x1.png",
        category: "mobilpynt",
        inStock: true,
    },
    {
       id: 19,
        name: "It's pink!",
        description: `Velg å være som du vil. Det er greit å like rosa. It goes with everything!`,
        price: 59,
        image: "/mobilpynt-3_1x1.png",
        category: "mobilpynt",
        inStock: true,
    },
];
